import React from 'react'
import { Link } from "react-router-dom";

const CtaSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <section className="cta-section">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="cta-text">
                            <h2>Ready to schedule a cleaning?</h2>
                            <Link onClick={ClickHandler} to="/book-now" className="theme-btn-s2">Book Now</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CtaSection;